import { Navigate, Route, Routes } from 'react-router';
import { RequireAuth } from './auth/AuthContext';
import { OperatorLayout } from './components/Layout';
import { AdminUsersPage } from './pages/AdminUsersPage';
import { ProfileDetailPage } from './pages/ProfileDetailPage';
import { ProfilesPage } from './pages/ProfilesPage';
import { CustomerViewerPage } from './pages/CustomerViewerPage';
import { InviteAcceptPage } from './pages/InviteAcceptPage';
import { JoinPage } from './pages/JoinPage';
import { LoginPage } from './pages/LoginPage';
import { NodesPage } from './pages/NodesPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { OperatorViewerPage } from './pages/OperatorViewerPage';
import { SettingsPage } from './pages/SettingsPage';
import { TestPage } from './pages/TestPage';

export function App() {
  return (
    <Routes>
      {/* public */}
      <Route path="/test" element={<TestPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/invite/:token" element={<InviteAcceptPage />} />
      {/* customer */}
      <Route path="/join" element={<JoinPage />} />
      <Route path="/join/:token" element={<JoinPage />} />
      <Route path="/support/:profileId" element={<CustomerViewerPage />} />
      {/* operator */}
      <Route element={<RequireAuth />}>
        <Route path="/profiles/:id/view" element={<OperatorViewerPage />} />
        <Route element={<OperatorLayout />}>
          <Route path="/" element={<Navigate to="/profiles" replace />} />
          <Route path="/profiles" element={<ProfilesPage />} />
          <Route path="/profiles/:id" element={<ProfileDetailPage />} />
          <Route path="/nodes" element={<NodesPage />} />
          <Route path="/admin/users" element={<AdminUsersPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
